export default __webpack_public_path__ + "static/media/event.f4faac16.svg";